import { all, call, put, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* get(action) {
  const { auditId, onSuccess, onError } = action.payload;
  const url = `${config.api.paths.auditComments}?audit_id=${auditId}`;

  try {
    const { data } = yield call(
      http.authorized.get, url
    );
    yield put(actionCreators.getSuccess(data));
  } catch (error) {
    logToSentry("On audit comments get:", { error });
    console.error(error);
    yield put(actionCreators.getFailure(error));
  }
}

function* post(action) {
  const { auditComment } = action.payload;
  const url = config.api.paths.auditComments;

  try {
    const { data } = yield call(http.authorized.post, url, auditComment);
    yield put(actionCreators.postSuccess(data));
  } catch (error) {
    logToSentry("On audit comments post:", { error });
    console.error(error);
    yield put(actionCreators.postFailure(error));
  }
}

function* patch(action) {
  const { id, data, auditId } = action.payload;
  const url = `${config.api.paths.auditComments}${id}/?audit_id=${auditId}`;

  try {
    const { data: updated } = yield call(http.authorized.patch, url, data);
    yield put(actionCreators.patchSuccess(updated));
  } catch (error) {
    logToSentry("On audit comments patch:", { error });
    yield put(actionCreators.patchFailure(error));
  }
}

export default function* () {
  yield all([
    takeLatest(actionTypes.AUDIT_COMMENT_GET_REQUEST, get),
    takeLatest(actionTypes.AUDIT_COMMENT_POST_REQUEST, post),
    takeLatest(actionTypes.AUDIT_COMMENT_PATCH_REQUEST, patch)
  ]);
}
